import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { CapaciteStepEnum } from '../../constants/capacite-step.enum';
import { STEPS_CONFIG } from './flow.config';
import { CapaciteSelectors } from '../../capacite.selectors';

@Injectable({
  providedIn: 'root'
})
export class FlowHelperService {
  constructor(private readonly store: Store) {}

  get nextStep() {
    const nextIndex = this.steps.indexOf(this.currentStep) + 1;
    return this.steps[nextIndex];
  }

  get previousStep() {
    const previousIndex = this.steps.indexOf(this.currentStep) - 1;
    return this.steps[previousIndex];
  }

  get isLastStep() {
    return this.nextStep === undefined;
  }

  get isFirstStep() {
    return this.previousStep === undefined;
  }

  get currentStepPosition() {
    return this.steps.indexOf(this.currentStep) + 1;
  }

  get totalSteps(): number {
    return this.steps.length;
  }

  get progressValue(): number {
    return Math.round(Math.max(0, (this.currentStepPosition / this.totalSteps) * 100));
  }

  get currentStep(): CapaciteStepEnum {
    return this.store.selectSnapshot(CapaciteSelectors.currentStep);
  }

  get steps(): CapaciteStepEnum[] {
    return STEPS_CONFIG.filter(config => !config.conditions || this.store.selectSnapshot(config.conditions())).map(
      config => config.step
    );
  }
}
